<template>
	<div class="container">
		<div class="row" style="margin-top: 15px;">
			<div id="left" class="widget m-0 widget-categories col-md-3 col-xs-12 hidden-xs">
				<!-- <div class="avatar-area">
					<el-upload name="avatarfile" :headers="headers" class="avatar-uploader" :action="uploadUrl"
						:show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="dataInfo.avatar!=''" class="avatar" :src="dataInfo.avatar" alt="">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<div class="name">{{dataInfo.nickName}}</div>
					<div class="company">{{dataInfo.workUnit}}</div>
				</div> -->
				<ul>
					<li v-for="(item,index) in softwareList" :key="index" @click="switchTab(item)">
						<div style="cursor: pointer;" href="" :class="item.id==id?'active':''" class="link">
							<span>{{item.name}}</span><span>></span>
						</div>
					</li>
				</ul>
			</div>
			<div id="right" class="col-md-9 col-xs-12">
				<div style="background-color: #fff;padding: 15px;width: 100%;min-height: 600px;">
					<div class="menu-name">{{menuName}}</div>
					<certificate v-if="id==1"></certificate>
					<order v-if="id==2"></order>
					<archives v-if="id==3"></archives>
					<exam v-if="id==4"></exam>
					<purchase v-if="id==5"></purchase>
					<inform v-if="id==6" type="2"></inform>
					<div v-if="id==7">
						<b-form @submit="onSubmit" v-if="show">
							<div class="label-name">
								<b-form-group id="input-group-1" label="用户头像:" label-for="input-1" label-cols-sm="2"
									label-align-sm="right">
									<div id="input-1" class="avatar-area">
										<el-upload name="file" :headers="headers" class="avatar-uploader"
											:action="uploadUrl" :show-file-list="false"
											:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
											<img class="avatar" :src="userInfo.avatar" alt="">
											<div slot="tip" class="el-upload__tip">点击图片上传真实头像（用于证书显示）</div>
										</el-upload>
									</div>
								</b-form-group>
							</div>
							<div class="label-name">
								<b-form-group id="input-group-2" label="用户名称:" label-for="input-2" label-cols-sm="2"
									label-align-sm="right">
									<b-form-input id="input-2" v-model="userInfo.nickName" placeholder="请输入用户名称"
										required></b-form-input>
								</b-form-group>
							</div>
							<div class="label-name">
								<b-form-group id="input-group-3" label="工作地点:" label-for="input-3" label-cols-sm="2"
									label-align-sm="right">
									<b-form-select required id="input-3" v-model="userInfo.workPlace"
										:options="placeOption" required></b-form-select>
								</b-form-group>
							</div>
							<div class="label-name">
								<b-form-group id="input-group-4" label="性别:" label-for="input-4" label-cols-sm="2"
									label-align-sm="right">
									<b-form-select required id="input-4" v-model="userInfo.sex" :options="sexOption"
										required></b-form-select>
								</b-form-group>
							</div>
							<div class="label-name">
								<b-form-group id="input-group-5" label="手机号码:" label-for="input-5" label-cols-sm="2"
									label-align-sm="right">
									<b-form-input required id="input-5" type='tel' v-model="userInfo.phonenumber"
										placeholder="请输入手机号码" required></b-form-input>
								</b-form-group>
							</div>
							<div class="label-name">
								<b-form-group id="input-group-6" label="邮箱:" label-for="input-6" label-cols-sm="2"
									label-align-sm="right">
									<b-form-input required id="input-6" v-model="userInfo.email" type="email"
										placeholder="请输入邮箱" required></b-form-input>
								</b-form-group>
							</div>
							<div class="label-name">
								<b-form-group id="input-group-7" label="工作单位:" label-for="input-7" label-cols-sm="2"
									label-align-sm="right">
									<el-select ref="mySelect" @visible-change="getCompany" :loading="loading" remote :remote-method="remoteMethod" required
										style="width: 70%!important;" v-model="userInfo.workUnit" filterable
										placeholder="请选择">
										<el-option class="select-opt" v-for="(item,index) in workOption" :key="index"
											:label="item.companyName" :value="item.companyName">
										</el-option>
									</el-select>
									<el-button style="margin-left: 10px;" size="small" type="success"
										@click="addUnit">新增单位</el-button>
								</b-form-group>
							</div>
							<div style="text-align: center;">
								<button type="submit" class="main-btn">提&nbsp;&nbsp;交</button>
							</div>
						</b-form>
						<b-modal ref="my-modal" title="新增单位">
							<label for="input-small">单位名称:</label>
							<b-form-input v-model="companyName" placeholder="请输入单位名称"></b-form-input>
							<template v-slot:modal-footer="{ ok, cancel, hide }">
								<b-button variant="success" @click="submit()">
									确定
								</b-button>
								<b-button variant="danger" @click="cancel()">
									取消
								</b-button>
							</template>
						</b-modal>
					</div>
				</div>
			</div>
		</div>
		<el-drawer size="50%" title="菜单" :visible.sync="drawer" direction="rtl">
			<div id="left" class="widget m-0 widget-categories col-md-3 col-xs-12">
				<ul>
					<li v-for="(item,index) in softwareList" :key="index" @click="switchTab(item)">
						<div href="" :class="item.id==id?'active':''" class="link">
							<span>{{item.name}}</span><span>></span>
						</div>
					</li>
				</ul>
			</div>
		</el-drawer>
	</div>
</template>
<script>
	import certificate from './certificate'
	import order from './order'
	import archives from './archives'
	import exam from './exam'
	import feedback from './feedback'
	import purchase from '../learnCode/purchase'
	import inform from '../collecting/index'
	import {
		getInfo,
		profile,
		getArea
	} from "@/api/login";
	import {
		companyList,
		addCompany,
		listByPage,
		companyName
	} from "@/api/userCenter";
	import {
		getToken
	} from "@/utils/auth";
	import Utils from '@/utils/callUtils';
	export default {
		components: {
			certificate,
			feedback,
			order,
			archives,
			exam,
			purchase,
			inform
		},
		data() {
			return {
				loading:false,
				drawer: false,
				headers: {
					Authorization: "Bearer " + getToken()
				},
				uploadUrl: process.env.VUE_APP_BASE_API + '/system/oss/upload',
				show: true,
				id: null,
				menuName: null,
				softwareList: [{
						id: 7,
						path: '/certificate',
						name: '个人资料'
					}, {
						id: 1,
						path: '/certificate',
						name: '我的证书'
					}, {
						id: 2,
						path: '/order',
						name: '我的订单'
					}, {
						id: 3,
						path: '/archives',
						name: '档案管理'
					}, {
						id: 4,
						path: '/exam',
						name: '我的考试'
					}, {
						id: 5,
						path: '/purchase',
						name: '苏学码购买'
					},
					{
						id: 6,
						path: '/feedback',
						name: '使用说明'
					},
				],
				placeOption: [{
					text: '请选择',
					value: ""
				}],
				sexOption: [{
					text: '请选择',
					value: "null"
				}, {
					text: '男',
					value: 0
				}, {
					text: '女',
					value: 1
				}],
				workOption: [],
				userInfo: {},
				dataInfo: {},
				companyName: "",
				comForm: {
					companyName: '',
					pageNum: 1,
					pageSize: 30
				}
			}
		},
		created() {
			if (this.$route.query.type) {
				this.id = this.$route.query.type
				this.menuName = this.softwareList.find(item => item.id == this.id).name
			}
			this.init()
			this.getUser()
		},
		mounted() {
			var that = this;
			Utils.$on('changeDrawer', function(param) {
				that.switchTab(param);
			})
		},
		methods: {
			addUnit() {
				this.companyName = ""
				this.$refs['my-modal'].show()
			},
			handleAvatarSuccess(res, file) {
				this.userInfo.avatar = res.data.url
				this.$message.success('头像修改成功!');
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === "image/png";
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					companyName(query).then(res => {
						if (res.code == 200) {
							this.workOption=res.data
							this.loading = false;
						} else {
							this.$message.error(res.msg);
						}
					})					
				} else {
					this.workOption = [];
				}
			},
			//新增单位
			submit() {
				if (this.companyName) {
					addCompany({
						companyName: this.companyName,
						createBy: this.userInfo.userName
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('新增成功！');
							this.$refs['my-modal'].hide()
							this.getCompany()
						} else {
							this.$message.error(res.msg);
						}
					})
				} else {
					this.$message.error('请输入单位名称！');
				}
			},
			getUser() {
				getInfo().then(res => {
					this.dataInfo = JSON.parse(JSON.stringify(res.data.user))
					this.userInfo = res.data.user
					if (!this.userInfo.avatar) {
						this.userInfo.avatar = require('../../assets/imgs/avatar.png')
					}
					this.getCompany()
					this.show = false
					this.$nextTick(() => {
						this.show = true
					})
				})
			},
			init() {
				this.placeOption = [{
					text: '请选择',
					value: null
				}]
				getArea().then(res => {
					res.data.forEach(item => {
						this.placeOption.push({
							text: item.name,
							value: item.name
						})
					})
				})
			},
			getCompany(row) {
				if (row) {
					this.workOption = []
					this.comForm.pageNum = 1
					this.comForm.companyName = row.toString() == 'true' ? '' : row
					listByPage(this.comForm).then(res => {
						this.workOption = res.rows
					})
					// 如果下拉框显示
					const selectDropdown = document.querySelector('.el-select-dropdown__wrap');
					// 监听下拉框滚动事件
					selectDropdown.addEventListener('scroll', this.loadNextPage);
				} else {
					// 如果下拉框隐藏
					const selectDropdown = document.querySelector('.el-select-dropdown__wrap');
					// 移除下拉框滚动事件监听
					selectDropdown.removeEventListener('scroll', this.loadNextPage);
				}
			},
			loadNextPage() {
				const selectDropdown = document.querySelector('.el-select-dropdown__wrap');
				// 判断下拉框是否触底
				if (selectDropdown.scrollTop + selectDropdown.offsetHeight >= selectDropdown.scrollHeight) {
					// 触底加载下一页数据
					this.comForm.pageNum++;
					listByPage(this.comForm).then(res => {
						this.workOption = this.workOption.concat(res.rows)
					})
				}
			},
			/** 切换tab */
			switchTab(item) {
				this.id = item.id
				this.menuName = item.name
			},
			onSubmit(event) {
				event.preventDefault()
				var reg = /^1[0-9]{10}$/
				if (this.userInfo.avatar.indexOf('data:image/png;base64,') > -1) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请上传头像！'
					})
				} else if (!reg.test(this.userInfo.phonenumber)) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请输入正确的手机号！'
					})
				} else {
					// this.userInfo.avatar = ''
					profile(this.userInfo).then(res => {
						if (res.code == 200) {
							this.$message({
								showClose: true,
								type: 'success',
								message: '修改成功！'
							})
							this.getUser()
						} else {
							this.$message({
								showClose: true,
								type: 'error',
								message: res.msg
							})
						}
					})
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	.menu-name {
		color: #547af8;
		font-size: 16px;
		font-weight: 700;
		border-bottom: 1px solid #e7e7e7;
		padding-bottom: 10px;
		position: relative;
		margin-bottom: 15px;
	}

	.menu-name::after {
		content: '';
		position: absolute;
		bottom: -1px;
		left: 0;
		width: 70px;
		height: 2px;
		background-color: #547af8;
	}

	.avatar-area {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.avatar {
			width: 80px;
			height: 80px;
			border-radius: 50%;
		}

		.name {
			font-size: 16px;
			color: #051c35;
			font-weight: 700;
			margin: 10px 0;
		}

		.company {
			color: #6f7987;
			font-size: 14px;
			margin-bottom: 10px;
		}
	}

	#left {
		margin: 50px 0;
	}

	.widget.widget-categories {
		background-color: white;
		padding: 18px;
		border-radius: 5px;
		max-height: 600px;
	}

	.widget.widget-categories h5.widtitle {
		font-size: 22px;
		line-height: 1.45;
		color: #051c35;
		font-weight: 600;
		padding-bottom: 24px;
	}

	.widget.widget-categories ul>li .link {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		border: 2px solid #f7f7f7;
		background-color: rgba(247, 247, 247, 0);
		height: 54px;
		line-height: 3.6;
		padding: 0px 20px 0px;
		margin-bottom: 15px;
		-webkit-transition: 0.5s;
		transition: 0.5s;
		position: relative;
	}

	.widget.widget-categories ul>li .link:after {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 0;
		content: '';
		background: rgba(255, 255, 255, 0);
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}

	.widget.widget-categories ul>li .link span {
		z-index: 1;
		font-size: 15px;
		line-height: 1.66;
		color: #6f7987;
		-webkit-transition: 0.4s;
		transition: 0.4s;
	}

	.widget.widget-categories ul>li .link:hover span {
		color: #fff;
	}

	.widget.widget-categories ul>li .link:hover:after {
		width: 100%;
		background: #547af8;
	}

	.widget.widget-categories ul>li .link.active span {
		color: #fff;
	}

	.widget.widget-categories ul>li .link.active:after {
		width: 100%;
		background: #547af8;
	}

	#right {
		min-height: 800px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 88px;
		height: 88px;
		line-height: 88px;
		border-radius: 10px;
		text-align: center;
	}

	.avatar {
		width: 88px;
		height: 88px;
		display: block;
		border-radius: 10px;
	}

	@media screen and (max-width: 997px) {
		#right {
			padding: 15px;
		}

		::v-deep .el-select-dropdown {
			width: 100px;
			background-color: #547af8;
		}

		.select-opt {
			width: 200px !important;
		}
	}
</style>